var propertyId = '';
var propertyTitle = '';

var sendingEmailFriend = false;

function click_envoyer_message(){
	if(sendingEmailFriend){
		return;
	}
	sendingEmailFriend = true;
	$('.modal-body  #help-block-message').empty();
	$('.modal-body  #help-block-mail').empty();
	$('.modal-body input#mail .help-block').hide();
	$('#contactFriendForm').submit(function(e){
		e.preventDefault();
	});
	var formulaire = $('#contactFriendForm').serialize();
	if(propertyId){
		var idAnnonce = propertyId;
	} else {
		var idAnnonce =$('.modal-body input#bienId').val();
	}
	$.ajax({
		url: '/partager-annonce/'+idAnnonce,
		type: 'POST',
		dataType: 'JSON',
		data: formulaire,
		success: function(data){
			//si il y a une erreur dans le mail
			if(typeof data === 'object'){
				if(data.mail){
					handleEmailFriendError(data.mail);
				}
			} else if(data === 'treatment-complete'){ // si c'est ok on envoit le mail
				handleEmailFriendComplete();
			} else { // Autres erreurs type CSRF
				handleEmailFriendError("Erreur lors de la tentative d'envoi du mail.");
			}
		}
	})
	.error(function(){
		handleEmailFriendError("Erreur lors de la tentative d'envoi du mail.");
	})
	.always(function(){
		sendingEmailFriend = false;
	});
}

function handleEmailFriendError(message){
	$('.modal-body  #help-block-mail').html(message);
	$('.modal-body  #help-block-mail').show();
	$('#help-block-mail').prev('.form-group').addClass('has-error');
	$('#help-block-mail').css( "color", "#a94442" );
}

function handleEmailFriendComplete(){
	$('.modal-body').html('<div class="alert alert-success">Votre e-mail a bien été envoyé.</div>');
	$('.envoyer_message').hide();
}

function click_listing_envoyer_message(){
	propertyId = $(this).data("property");
	propertyTitle = $(this).data("title");
	$('h4.modal-title').html('Envoyer l\'annonce par e-mail : '+propertyTitle);

	$('.envoyer_message').click(function(){
		click_envoyer_message();
	});
}

$(document).ready(function(){
	$(".share-btn-sendfriend").click(function(){
		click_listing_envoyer_message();
	});	
});

